import Link from 'antd/lib/typography/Link';
import moment from 'moment';
import React from 'react';
import styles from './Style/Notifications.module.scss';
import DOMPurify from 'dompurify';
import {nicelyFormatDate} from "../../../utils/common";
import {INotification} from "./INotification";

interface IProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * Notifications of one day.
   */
  notification: INotification;
  /**
   * Link href.
   */
  href?: string;
  /**
   * Link callback.
   */
  onLinkCallBack?: (arg0: INotification) => void;
  /**
   * Custom render function.
   * To display the content of a notification item.
   */
  renderContent?: (notification: INotification) => React.ReactNode | string;
  /**
   * Custom render function.
   * To display the title of a notification item.
   */
  renderTitle?: (notification: INotification) => React.ReactNode | string;
}

/**
 * @name MikeNotificationItem
 * @summary A single notification icon, meant to be rendered by a notification item group.
 */
export const MikeNotificationItem = ({
  notification,
  href,
  onLinkCallBack,
  renderContent,
  renderTitle,
}: IProps) => {
  const title = notification.title;

  const handleClick = (currentNotification: INotification) => (e: any) => {
    if (onLinkCallBack) {
      e.preventDefault();
      onLinkCallBack(currentNotification);
    }
  };

  return (
    <div className={styles.notificationItem}>
      {renderTitle ? (
        renderTitle(notification)
      ) : (
        <div className={styles.notificationTitle}>{title}</div>
      )}
      {renderContent ? (
        renderContent(notification)
      ) : (
        <>
          {notification.message && (
            <div className={styles.notificationText} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification.message)}}/>
          )}
          <div className={styles.notificationText}>
            {nicelyFormatDate(moment(notification.time), true)}
          </div>
        </>
      )}

      {notification.hasLink && (
        <Link
          href={notification.link}
          target="_blank"
          rel="noopener"
          onClick={handleClick(notification)}
          className={styles.notificationLink}
        >
          {notification.linkLabel ? notification.linkLabel : 'See details'}
        </Link>
      )}
      {notification.image && (
        <div className={styles.notificationImg}>
          <img src={notification.image} alt="" />
        </div>
      )}
    </div>
  );
};

export default MikeNotificationItem;
